import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
 
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
Vue.component(FeatherIcon.name, FeatherIcon)
